import Component from 'classes/Component'
import GSAP from 'gsap'

export default class AsyncLoad extends Component {
  constructor ({ element }) {
    super({ element })

    this.createObserver()
  }

  createObserver () {

  }
}
